module.exports = __webpack_public_path__ + "img/man-icon.591999bb.svg";